import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Label,
  Input,
  InputGroup,
  InputGroupText,
  Table,
} from "reactstrap";
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import ModerationSettingModal from "../../components/modals/ModerationSettingModal";

import PaginatedItems from "../../components/PaginatedItems";
import {
  fetchAllkeyword,
  fetchAllReport,
  reportsStatus,
} from "../../http/http-calls";
import moment from "moment/moment";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  copyToClipBoard,
  deepClone,
  convertUrlToCdn,
} from "../../helper-methods";
import { Oval } from "react-loader-spinner";
import { ReadMore } from "../../components/ReadMore";

const ModerationPage = () => {
  //state
  const [isEmbeddedLoading, setIsEmbeddedLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState("");
  const [keyWords, setKeyWords] = useState([]);
  // date range
  const [filters, setFilters] = useState({
    dateRange: {
      startDate: null,
      endDate: null,
    },
  });

  const [count, setCount] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const [payload, setPayload] = useState({
    pageNumber: 1,
    pageSize: 10,
  });
  const [report, setReport] = useState([]);
  const [flag, setFlag] = useState(false); // for button disabled after one click

  const _onDatesChange = (field, startDate = null, endDate = null) => {
    const newFilters = { ...filters };

    newFilters["dateRange"] = {
      startDate,
      endDate,
    };
    setFilters(newFilters);
    if (
      newFilters.dateRange.startDate !== null &&
      newFilters.dateRange.endDate !== null
    ) {
      const newSearchData = payload;

      let start = moment(newFilters?.dateRange?.startDate?._d).format(
        "DD/MM/YYYY",
      );
      let end = moment(newFilters?.dateRange?.endDate?._d).format("DD/MM/YYYY");

      newSearchData[field] = `${start}-${end}`;
      setPayload(newSearchData);
      setPayload({ ...payload, pageNumber: 1 });
      _checkHandler(payload);
    }
  };

  const _toggle = (isOpen = false) => {
    setIsOpen(isOpen);
    if (isOpen) {
      _fetchKeyword();
    }
  };

  //see all keywords
  const _fetchKeyword = async () => {
    try {
      const res = await fetchAllkeyword();
      // console.log("allKeyWord", res);
      setKeyWords(res.settings[0].keyWords);
      setId(res.id);
    } catch (error) {
      // console.log(error);
    }
  };

  //see all reports
  const _fetchReports = async (newPayload) => {
    if (newPayload) {
      try {
        const res = await fetchAllReport(newPayload);
        // console.log("allReports", res);
        setReport(res.data);
        setCount(res.reportsCount);
        setItemPerPage(res.data.length);
        setIsEmbeddedLoading(false);
      } catch (error) {
        // console.log(error);
        setIsEmbeddedLoading(false);
      }
    } else {
      // Show embedded loader for filtering/pagination, not initial load
      setIsEmbeddedLoading(true);

      try {
        const res = await fetchAllReport(payload);
        // console.log("allReports", res);
        setReport(res.data);
        setCount(res.reportsCount);
        setItemPerPage(res.data.length);
        setIsEmbeddedLoading(false);
      } catch (error) {
        // console.log(error);
        setIsEmbeddedLoading(false);
      }
    }
  };
  /* eslint-disable */
  useEffect(() => {
    _fetchReports();
  }, []);

  //status change
  const _changeStatus = async (event, id, index) => {
    setFlag(true);

    let oldReports = JSON.parse(JSON.stringify(report));

    const value = event.target.value;
    report[index].status = value;

    setReport([...report]);
    try {
      const res = await reportsStatus(id, { status: value });
      // console.log("searchFilter>>", res);
      copyToClipBoard("status", event.target.value);
    } catch (error) {
      setReport(oldReports);

      // console.log(error);
    }
    setFlag(false);
  };

  //debounce function
  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  //filter and search
  const _statusHandler = async (field, event) => {
    const newSearchData = payload;
    newSearchData[field] = event.target.value;
    // setSearchData(newSearchData);

    if (event.target.value.length) {
      newSearchData[field] = event.target.value;
      setPayload({ ...payload, pageNumber: 1 });
    } else {
      // console.log("field >>", field);
      delete newSearchData[field];
    }
    // setSearchData(newSearchData);
    // console.log("newSearchFilterData >", newSearchData);
    _checkHandler(newSearchData, null);
  };

  //debounce function call
  const optimizedFn = useCallback(debounce(_statusHandler), []);

  //api call for filter and search
  const _checkHandler = async (data) => {
    // console.log("check>>", data);
    setIsEmbeddedLoading(true);

    try {
      const res = await fetchAllReport(payload);
      // console.log("searchFilter>>", res);
      setReport(res.data);
      setCount(res.reportsCount);
      setItemPerPage(res.data.length);
      setIsEmbeddedLoading(false);
    } catch (error) {
      // console.log(error);
      setIsEmbeddedLoading(false);
    }
  };

  //pagination

  const handlePageClick = (pageNumber) => {
    // console.log(pageNumber);
    let newPageConfig = deepClone(payload);
    newPageConfig["pageNumber"] = pageNumber + 1;
    setPayload(newPageConfig);
    setIsEmbeddedLoading(true);
    _fetchReports(newPageConfig);
  };

  return (
    <>
      <div className="innerHeader">
        {/* page title */}
        <h2>Moderation</h2>
        <div className="right">
          <Button onClick={() => _toggle(true)} color="primary">
            Settings
          </Button>
        </div>
      </div>

      {/* filter */}
      <div className="filterWrapper">
        <div className="filterIcon">
          <i className="fas fa-filter"></i>
        </div>

        <div className="filterForm">
          <div className="formGroup">
            <Label>Type</Label>
            <Input
              type="select"
              onChange={(event) => optimizedFn("type", event)}
            >
              <option value="">All</option>
              <option value="Post">Feed Post</option>
              <option value="Topic">Forum Topic</option>
              <option value="Media">Media</option>
            </Input>
          </div>

          <div className="formGroup">
            <Label>Status</Label>
            <Input
              type="select"
              onChange={(event) => optimizedFn("status", event)}
            >
              <option value="">All</option>
              <option value="Pending">Pending</option>
              <option value="Removed">Removed</option>
              <option value="Ignored">Ignored</option>
            </Input>
          </div>

          <div className="formGroup">
            <Label>Date Range</Label>
            <CustomDateRangePicker
              startDate={filters.dateRange.startDate}
              endDate={filters.dateRange.endDate}
              startDateId={"startDate_kpi_dashboard"}
              endDateId={`endDate_kpi_dashboard`}
              onDatesChange={(startDate, endDate) =>
                _onDatesChange("dateRang", startDate, endDate)
              }
            />
          </div>

          {/* search */}
          <div className="formGroup searchbar">
            <Label>Search</Label>
            <InputGroup>
              <Input
                placeholder="Search..."
                onChange={(event) => optimizedFn("searchText", event)}
              />
              <InputGroupText>
                <i className="fas fa-search"></i>
              </InputGroupText>
            </InputGroup>
          </div>
        </div>
      </div>

      <React.Fragment>
        <div className="bg-white p-2 mt-4" style={{ borderRadius: 8 }}>
          {isEmbeddedLoading ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                margin: "40px 0",
                minHeight: "200px",
                alignItems: "center",
              }}
            >
              <Oval color="#3498DB" />
            </div>
          ) : (
            <Table responsive>
              <thead>
                <tr>
                  <th>Group</th>
                  <th>Date</th>
                  <th>Reported By</th>
                  <th>Post/Topic/Media</th>
                  <th>Status</th>
                </tr>
              </thead>

              {report?.map((item, index) => (
                <tbody key={index}>
                  <tr>
                    <td className="text-capitalize">
                      <Link to={`/groups-view/${item._group?._id}`}>
                        {item._group?.name}
                      </Link>
                    </td>
                    <td>
                      {moment(item.createdAt).format("DD")}
                      <sup>st</sup> {moment(item.createdAt).format(" MMM")}
                    </td>
                    <td>
                      <Link to={`/members-view/${item._user?._id}`}>
                        {item._user.fullname}
                      </Link>
                    </td>
                    <td>
                      {item.type === "Media" ? (
                        convertUrlToCdn(item._post?.caption)
                      ) : item._post?.caption.length < 50 ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item._post?.hasOwnProperty("caption")
                              ? item._post?.caption
                              : "Removed",
                          }}
                        ></div>
                      ) : (
                        <ReadMore maxlength={50}>
                          {item._post?.hasOwnProperty("caption")
                            ? item._post?.caption
                            : "Removed"}
                        </ReadMore>
                      )}
                    </td>
                    <td>
                      <div className="action">
                        <Input
                          type="select"
                          value={item.status}
                          onChange={(event) =>
                            _changeStatus(event, item?._id, index)
                          }
                          disabled={item.status === "Removed" || flag === true}
                        >
                          <option value="Pending">Pending</option>
                          <option value="Removed">Removed</option>
                          <option value="Ignored">Ignored</option>
                        </Input>
                      </div>
                    </td>
                  </tr>
                </tbody>
              ))}
            </Table>
          )}
        </div>
      </React.Fragment>

      <ToastContainer
        position="bottom-right"
        autoClose={1000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <ModerationSettingModal
        isOpen={isOpen}
        toggle={() => _toggle()}
        id={id}
        keyWords={keyWords}
      />
      {/* pagination */}
      <PaginatedItems
        itemsPerPages={itemPerPage}
        totalCount={count}
        selectedPage={payload.pageNumber}
        itemsPerPage={payload.pageSize}
        onPageChange={handlePageClick}
      />
    </>
  );
};

export default ModerationPage;
